import { Injectable } from "@angular/core";
import { ContextService } from '../core/context.service';

declare const MCCordovaPlugin: any;

export interface MCNotification {
  message?: string;
  type?: string;
  values?: object;
  timestamp: number;
}

@Injectable({
  providedIn: "root",
})
export class MarketingCloudPluginService {

  constructor(private ctx: ContextService) {}

  async enablePush(contactKey: string) {
    await this.ctx.assertCordova();
    return new Promise<void>((resolve, reject) => {
      MCCordovaPlugin.enablePush(() => {
        this.setContactKey(contactKey, resolve, reject);
      }, reject);
    });
  }

  async disablePush() {
    await this.ctx.assertCordova();
    return new Promise<void>((resolve, reject) => {
      MCCordovaPlugin.disablePush(resolve, reject);
    });
  }

  async isPushEnabled() {
    await this.ctx.assertCordova();
    return new Promise<boolean>((resolve, reject) => {
      MCCordovaPlugin.isPushEnabled(resolve, reject);
    });
  }

  async isMarketingCloudPush(extras: any) {
    await this.ctx.assertCordova();
    return new Promise<boolean>(resolve => {
        MCCordovaPlugin.isMarketingCloudPush(
            { extras },
            () => { resolve(true); },
            () => { resolve(false); }
        );
    });
  }

  async handleNotification(extras: any) {
    await this.ctx.assertCordova();
    return new Promise<void>((resolve, reject) => {
      MCCordovaPlugin.handleNotification({ extras }, resolve, reject);
    });
  }

  async notifyPushOpened(extras: any) {
    await this.ctx.assertCordova();
    MCCordovaPlugin.notifyPushOpened({ extras });
  }

  async setOnNotificationOpenedListener(callback: (event: MCNotification) => void) {
    await this.ctx.assertCordova();
    return MCCordovaPlugin.setOnNotificationOpenedListener(callback);
  }

  private async setContactKey(
      contactKey: string, onSuccess: (key: any) => void, onError: () => void) {
    await this.ctx.assertCordova();
    return MCCordovaPlugin.setContactKey(contactKey, onSuccess, onError);
  }

}
